import { defineComponent as n, openBlock as r, createBlock as l, unref as p, mergeProps as m, withCtx as i, createElementVNode as e } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconCookie",
  __name: "IconCookie",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (d, o) => (r(), l(p(c), m(t, { "view-box": "0 0 24 24" }), {
      default: i(() => [...o[0] || (o[0] = [
        e("path", { d: "M7 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-6.25-2a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m9.75 5.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-4.75 2.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M12.852 3.187a.75.75 0 0 0-.79-.934L12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75q0-.031-.003-.062a.75.75 0 0 0-.934-.79A3.25 3.25 0 0 1 16.75 8 .75.75 0 0 0 16 7.25a3.25 3.25 0 0 1-3.148-4.063M20 12.75a5 5 0 0 0 .217-.005 8.25 8.25 0 1 1-8.962-8.962A4.75 4.75 0 0 0 15.3 8.7a4.75 4.75 0 0 0 4.7 4.05",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M17.5 4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M20 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
